<template>
  <div class="page third-repay">
    <navigation>三方授权还款</navigation>
    <section v-if="billList.length === 0" class="no-data">
      <img src="./images/no_history.png">
      <div class="tips">这里空空如也...</div>
    </section>
    <!-- v-if="creditStatus === 'OVERDUE' || creditStatus === 'PENDING'" -->
    <div v-else class="bill-list">
      <div class="bill-title">
        <span class="prefix">
          三方授权&nbsp;
        </span>
        <span class="repay-amount">
          |&nbsp;&nbsp;当前可还总额(元) 
          <em>
            {{ totalAmount | currency}}
          </em>
        </span>
      </div>

      <!-- 在途或逾期 -->
      <template >

        <nd-cell v-for="(item, index) in billList" :key="index" class="panel" data-sensors-click :content="true" @click="goRepayment(item.type)">
          <span slot="title">{{ platform(item.type).name }}
            <img v-if="item.hasOverdueOrder" src="./images/img_yuqi@2x.png" alt="" class="third-icon">
          </span>
          <!-- <span slot="text" class="status" v-if="item.hasOverdueOrder" :class="{ 'overdue': item.hasOverdueOrder }">已逾期</span> -->
          <div class="panel-content">
            <div class="left">
              <p class="top">{{ item.orderOutLineInfo.length }}</p>
              <span class="description">进行中 (笔)</span>
              <!-- <span>当前应还<em >¥{{ item.totalAmount | currency }}</em></span> -->
            </div>
            <div class="right">
              <p class="top">{{ item.totalAmount | currency }}</p>
              <span class="description">当前可还 (元)</span>
            </div>
                                
          </div>
        </nd-cell> 
      </template>
                    
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { getKey, setKey } from '../../assets/utils'

export default {
  name: 'third-repay',
  data () {
    return {

    }
  }, 
  async created () {
    try {
      await Promise.all([
        this.getOrderOutLine(),
        this.getPlatform()
      ])
      this.$bus.$emit('ready')
    } catch (exp) {
      this.$bus.$emit('error')
    }
  },
  methods: {
    ...mapActions('order', ['getOrderOutlineX', 'getPlatformX']),
    // 去还款
    goRepayment (type) {
      this.$report({
        id: 10132,
        args: {
          position: type
        }
      })
      const params = {
        type: type
      }
      this.$router.push({ path: '/repayment', query: params })
    },

    // 获取订单概要
    getOrderOutLine () {
      return this.getOrderOutlineX()
    },

    platform (type) {
      const platform = getKey('platform')
      const result = platform && platform.find(item => item.loanPlatform === type)
      if (result) {
        return {
          name: result.loanPlatformName,
          icon: result.iconUrl
        }
      }
      return {
        name: platform['TMD'] && platform['TMD'].loanPlatformName,
        icon: platform['TMD'] && platform['TMD'].iconUrl
      }
    },
    // 获取平台枚举
    async getPlatform () {
      const res = await this.getPlatformX()
      if (res.code === '000000') {
        setKey('platform', res.data)
      }
    }
  },
  computed: {
    ...mapState('user', {
      userInfo: state => state.userInfo
    }),
    ...mapState('order', {
      creditStatus: state => {
        // 未登录 
        if (state.statusCode === '000005') {
          return 'UN_LOGIN'
          // 有逾期账单
        } else if (getKey('userInfo', 'wu') === false) {
          return 'BLACK'
        } else if (state.outlineInfo.sysHasOverdueOrder === true) {
          return 'OVERDUE'
          // 无账单
          // } else if (state.outlineInfo.sysCompleted === true) {
          //     return 'NO_BILL'
          // 系统维护中
        } else if (state.statusCode === '999999') {
          return 'SYSTEM'
        } else if (state.outlineInfo.sysOrderLine && state.outlineInfo.sysOrderLine.length > 0) {
          // 有在途订单
          return 'PENDING'
        } else {
          return 'NO_BILL'
        }
      },
                
      billList: state => {
        return state.outlineInfo.sysOrderLine
      }, 
      totalAmount: state => {
        return state.outlineInfo.sysTotalAmount
      }
    })
  }
}
</script>

<style lang='less'>
@import "../../assets/less/mixin.less";

    .third-repay {
        background: #FAFAFA;
        .bill-list {
            background-color: #F7F7F7;
            // margin-top: 192px;
            padding:0px 40px 0px 40px;

            .bill-title {
                background:rgba(241,241,241,1);
                border-radius:16px;
                background-color: #F1F1F1;
                margin-top: 90px;
                padding: 30px;
                .prefix {
                    font-size:28px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:@fc2;
                    line-height:40px;
                }
                .repay-amount {
                    font-size:28px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(153,153,153,1);
                    line-height:40px;
                    color: @fc3;
                    
                    em {
                        font-family: DIN-Medium;
                        font-style: normal;
                        color: @fc2;
                    }
                }
            }
            
            .title {
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                color:rgba(51,51,51,1);
                line-height:45px;
                margin-left: 5px;
            }

            .panel {
                margin-top: 30px;
                border-radius: 16px;
                .third-icon{
                    width: 100px;
                    height: 46px;
                    position: relative;
                    top: 12px;
                }
                
                .overdue {
                    margin-left: 40px;
                    font-size:28px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    line-height:40px;
                    color: @fc-error;
                }

                .panel-content {
                    padding: 42px 82px 42px 100px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    border-top: 1px solid @iuc;
                    text-align: center;

                    .top {
                        font-size:34px;
                        font-family:DIN-Medium,DIN;
                        font-weight:500;
                        color:rgba(51,51,51,1);
                        line-height:41px;
                    }
                    .description {
                        font-size:28px;
                        font-family:PingFangSC-Regular,PingFang SC;
                        font-weight:400;
                        color:rgba(102,102,102,1);
                        line-height:40px;
                    }
                }
            }
        }
        .no-data {
            width: 100%;
            text-align: center;
            img {
                width: 408px;
                height: 250px;
                margin-top: 263px;
            }

            .tips {
                margin-top: 30px;
                font-size: 26px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: 36px;
            }
        }
    }
</style>
